import { useEffect } from "react";

export const useJsonLd = (id, data) => {
  useEffect(() => {
    if (!data) return;
    let tag = document.getElementById(id);
    if (!tag) {
      tag = document.createElement("script");
      tag.id = id;
      tag.type = "application/ld+json";
      document.head.appendChild(tag);
    }
    tag.textContent = JSON.stringify(data);
    return () => tag.remove();
  }, [id, JSON.stringify(data)]);
};
